import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import { getGamAdUnitSizesService } from '../../../../../../../../modules/services/googleAdManager'
import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'

import {
  getInventoryItemIdFieldName,
  getInventoryItemId
} from '../../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'

import { GAM_NETWORK_CODE } from '../../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'

export const useFetchAdUnitSizes = ({ isOpened, inventory }) => {
  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const [wasLoaded, setWasLoaded] = useState(false)

  const idFieldName = getInventoryItemIdFieldName(inventory[0])

  const inventoryIds = useMemo(() => {
    return inventory.map(item => getInventoryItemId(item)).join(',')
  }, [inventory])

  const { data, error, isLoading } = useQuery({
    queryKey: ['lineItemAdsForecast', inventoryIds],
    queryFn: () =>
      getGamAdUnitSizesService({
        network_code: gamNetworkCode,
        // todo: We need to pass list of ids separated by commas when API will support it
        [idFieldName]: getInventoryItemId(inventory[0])
      }).then(response => {
        setWasLoaded(true)
        return response
      }),
    enabled: isOpened && !wasLoaded,
    retry: false
  })

  return {
    data,
    error,
    isLoading
  }
}
